(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});


parcelRegister("7PKI7", function(module, exports) {

$parcel$export(module.exports, "bootBlock", function () { return $5b418790771612cf$export$3ba659c19d85cb2f; });
$parcel$export(module.exports, "scoped", function () { return $5b418790771612cf$export$6387ff77edd805b9; });
$parcel$export(module.exports, "claim", function () { return $5b418790771612cf$export$dac5a380ed022e46; });
$parcel$export(module.exports, "listenWhileConnected", function () { return $5b418790771612cf$export$1739974940b15ce8; });
/**
 * Shared boot for the theme block scripts (blocks/*).
 *
 * Every block script keeps its behavior in one initializer, `initialize(root, options)`:
 * - Frontend: called once with the whole document after DOMContentLoaded (or right away when the document
 *   is already parsed), or after `load` for scripts that always waited for it.
 * - Block editor canvas: handed to the canvas runtime (inc/Blocks/block-canvas.js), which calls it with the
 *   preview root after every ACF preview render, with { isEditor: true, autoplay: false }.
 *
 * ACF re-renders previews by reconciling the same DOM, so initializers run repeatedly: bind through claim()
 * so each element is wired once, and remove window/document listeners when the block leaves the canvas.
 */ function $5b418790771612cf$export$3ba659c19d85cb2f(slug, initialize) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_waitFor = _ref.waitFor, waitFor = _ref_waitFor === void 0 ? 'DOMContentLoaded' : _ref_waitFor;
    if (window.juniperBlockRuntime) {
        window.juniperBlockRuntime.register(slug, initialize);
        return;
    }
    var run = function() {
        return initialize(document, {
            isEditor: false,
            autoplay: true
        });
    };
    if (waitFor === 'load') {
        if (document.readyState === 'complete') run();
        else window.addEventListener('load', run, {
            once: true
        });
    } else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {
        once: true
    });
    else run();
}
function $5b418790771612cf$export$6387ff77edd805b9(root, selector) {
    return root.nodeType === Node.DOCUMENT_NODE ? selector : root.querySelector(selector);
}
function $5b418790771612cf$export$dac5a380ed022e46(element) {
    var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'juniperReady';
    if (!element || element.dataset[key] === 'true') return false;
    element.dataset[key] = 'true';
    return true;
}
function $5b418790771612cf$export$1739974940b15ce8(target, type, handler, owner, options) {
    var listener = function(event) {
        if (!owner.isConnected) {
            target.removeEventListener(type, listener, options);
            return;
        }
        handler(event);
    };
    target.addEventListener(type, listener, options);
}

});


var $2Xzd1 = parcelRequire("2Xzd1");

var $7PKI7 = parcelRequire("7PKI7");
// One state object per block instance (the editor canvas can hold several instances and re-renders them).
var $01ce6d9a201517b1$var$createBlogPostsPaginationAjax = function(root) {
    var blogPostsPaginationAjax = {
        settings: {
            filter: '',
            postsNumber: 0,
            offset: 0
        },
        init: function init(owner) {
            var _this = this;
            this.categoryChangeHandler();
            this.changePageWithPageNumberButtonHandler(owner);
            this.checkHash();
            this.changePageHandler(owner);
            (0, $7PKI7.listenWhileConnected)(window, 'hashchange', function() {
                _this.checkHash();
            }, owner);
        },
        changePageHandler: function(owner) {
            // Use event delegation on a parent container that exists on page load
            (0, $7PKI7.listenWhileConnected)(root, 'click', function(e) {
                // Check if the clicked element or its parent matches our pagination arrows
                var targetButton = e.target.closest('.blog-posts-pagination__pagination-prev, .blog-posts-pagination__pagination-next');
                if (targetButton) {
                    var arrowDirection = targetButton.getAttribute('data-nav');
                    var currentPage = blogPostsPaginationAjax.getActivePage();
                    if (arrowDirection === 'prev') {
                        if (currentPage > 1) {
                            var page = parseInt(currentPage) - 1;
                            // set offset based on the page number
                            blogPostsPaginationAjax.settings.offset = (page - 1) * blogPostsPaginationAjax.settings.postsNumber;
                            blogPostsPaginationAjax.getBlogPosts(false);
                        }
                    } else {
                        var totalPages = root.querySelector('.blog-posts-pagination__pagination-pages').dataset.totalPages;
                        if (currentPage < totalPages) {
                            var page1 = parseInt(currentPage) + 1;
                            // set offset based on the page number
                            blogPostsPaginationAjax.settings.offset = (page1 - 1) * blogPostsPaginationAjax.settings.postsNumber;
                            blogPostsPaginationAjax.getBlogPosts(false);
                        }
                    }
                }
            }, owner);
        },
        changePageWithPageNumberButtonHandler: function(owner) {
            (0, $7PKI7.listenWhileConnected)(root, 'click', function(e) {
                var link = e.target.closest('.blog-posts-pagination__pagination-page-number');
                if (link && link.closest('.blog-posts-pagination__pagination-pages') && !link.classList.contains('var_active') // skip if already active
                ) {
                    var page = link.getAttribute('data-page');
                    blogPostsPaginationAjax.settings.offset = (parseInt(page) - 1) * blogPostsPaginationAjax.settings.postsNumber;
                    blogPostsPaginationAjax.getBlogPosts(false);
                }
            }, owner);
        },
        getActivePage: function() {
            var paginationNumbers = root.querySelector('.blog-posts-pagination__pagination-pages .blog-posts-pagination__pagination-page-number.var_active');
            if (paginationNumbers) return paginationNumbers.getAttribute('data-page');
            else return 1;
        },
        categoryChangeHandler: function() {
            var filters = root.querySelectorAll('.blog-posts-pagination__categories li');
            filters.forEach(function(filter) {
                filter.addEventListener('click', function() {
                    if (blogPostsPaginationAjax.settings.filter === filter.getAttribute('data-id')) return;
                    var lastActiveFilter = root.querySelector('.blog-posts-pagination__categories li.var_active');
                    blogPostsPaginationAjax.settings.filter = filter.getAttribute('data-id');
                    filter.classList.add('var_active');
                    lastActiveFilter.classList.remove('var_active');
                    blogPostsPaginationAjax.resetPagination();
                    blogPostsPaginationAjax.getBlogPosts();
                });
            });
            blogPostsPaginationAjax.settings.postsNumber = (0, $2Xzd1._)(root.querySelectorAll('.blog-tile-new')).length;
        },
        resetPagination: function() {
            blogPostsPaginationAjax.settings.offset = 0;
        },
        getBlogPosts: function() {
            var loader = root.querySelector('.loader-container');
            var ajax_data = {
                action: 'blog-posts-pagination',
                filter: blogPostsPaginationAjax.settings.filter,
                postsNumber: blogPostsPaginationAjax.settings.postsNumber,
                offset: blogPostsPaginationAjax.settings.offset
            };
            jQuery.ajax({
                type: 'GET',
                url: ajax.ajax_url,
                data: ajax_data,
                beforeSend: function() {
                    loader.classList.add('var_active');
                },
                success: function(data) {
                    var response = data.data;
                    var html = response.html;
                    var productsContainer = root.querySelector('.blog-posts-pagination__posts .row');
                    var paginationContainer = root.querySelector('.blog-posts-pagination__pagination');
                    if (paginationContainer) paginationContainer.innerHTML = response.pagination_html;
                    jQuery(productsContainer).html(html);
                    // Calculate dynamic offset based on present elements
                    var element = root.querySelector('.blog-posts-pagination');
                    // Dynamically calculate offset based on which elements are present
                    var offsetHeight = 0;
                    var topBanner = document.querySelector('.header__top-banner-cta-bar');
                    var adminBar = document.querySelector('#wpadminbar');
                    if (topBanner) offsetHeight += topBanner.offsetHeight;
                    if (adminBar) offsetHeight += adminBar.offsetHeight;
                    // Apply the dynamic scroll margin
                    element.style.scrollMarginTop = offsetHeight + 'px';
                    element.scrollIntoView({
                        behavior: 'smooth'
                    });
                    loader.classList.remove('var_active');
                    if (window.location.hash) // Just in case the above scroll didn't work with the hash
                    setTimeout(function() {
                        element.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }, 100);
                },
                error: function(xhr, status, errorThrown) {
                    alert('Something went wrong. Please try later. ');
                }
            });
        },
        checkHash: function() {
            var hash = window.location.hash;
            if (hash) {
                var clearHash = hash.slice(hash.indexOf('#') + 1);
                var filter = root.querySelector('.blog-posts-pagination__categories li[data-slug="'.concat(clearHash, '"]'));
                filter === null || filter === void 0 ? void 0 : filter.click();
            }
        }
    };
    return blogPostsPaginationAjax;
};
(0, $7PKI7.bootBlock)('blog-posts-pagination', function(root) {
    var section = root.querySelector('.blog-posts-pagination');
    if ((0, $7PKI7.claim)(section, 'juniperAjax')) $01ce6d9a201517b1$var$createBlogPostsPaginationAjax(root).init(section);
});

})();
//# sourceMappingURL=ajax.js.map
